import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyDontShowControl } from "../controls/gamevy-dont-show-control";

export class GamevyDontShowControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiToggle("gamevy_dont_show_toggle") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        const toggle = layer.getFlexiToggle("gamevy_dont_show_toggle");
        return [new GamevyDontShowControl(toggle)];
    }
}
